import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertModalService } from 'app/shared/alert-modal.service';
import { CargoApiService } from 'app/api/cargoApi.service';
import { ClienteApiService } from 'app/api/clienteApi.service';
import { ServicoApiService } from 'app/api/servicoApi.service';
import { UsuariosService } from 'app/api/usuarios.service';
import { 
  PessoaJuridica,
  Servico 
} from 'app/model/models';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { DataTableDirective } from 'angular-datatables';
import { LanguageDataTable } from 'app/shared/datatable/translate-datatable';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-cargos-modelos-cadastrar',
  templateUrl: './cargos-modelos-cadastrar.component.html',
  styleUrls: ['./cargos-modelos-cadastrar.component.css']
})
export class CargosModelosCadastrarComponent implements OnInit, OnDestroy {

  clientes$: Observable<PessoaJuridica[]>;
  servico$: Observable<Servico[]>;
  servicoSelect: string;
  addFormBasico: FormGroup;
  usuarioLogado: number;
  usuarioNome: string;
  dadosBasicosSalvos = false;
  initUnidades: number;
  unidades: number;
  
  nomeCliente: string;
  idCliente: number;
  nomeCargo: string;
  idCargo: number;
  idServico: number;
  submitted = false;
  carregando = false;
  order = 'nomeArquivoOrigem';
  reverse = false;
  atualizando = false;

  @ViewChild(DataTableDirective, {static: false})
  datatableElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  orderCondition: number = 3;

  @ViewChild('linkBasicsData') linkBasicsData: ElementRef;
  @ViewChild('basicsData') basicsData: ElementRef;
  @ViewChild('linkProfile') linkProfile: ElementRef;
  @ViewChild('profile') profile: ElementRef;

  private subs = new SubSink();

  constructor(
    private cargosService: CargoApiService,
    private usuariosService: UsuariosService,
    private clientesService: ClienteApiService,
    private servicosService: ServicoApiService,
    private formBuilder: FormBuilder,
    private location: Location,
    private router: Router,
    private alertService: AlertModalService
  ) {
    this.addFormBasico = this.formBuilder.group({
      titulo: ['', Validators.required],
      descricao: [''],
      area: [''],
      nivel: [''],
      pessoaJuridicaId: [''],
      servicoId: [null], 
      qtdeUnidades: [0],
      addUnidades: [0],
      urlLink: [''],
      tipoCargo: ['Modelo'],
    });
  }

  ngOnInit() {
    this.subs.sink = this.usuariosService.v1UsuariosLogadoGet()
    .subscribe(usuario => {
        this.usuarioLogado = usuario.pessoaJuridicaId;
        this.usuarioNome = usuario.userName;
        if (this.usuarioLogado !== null && typeof this.usuarioLogado !== 'undefined' ) {
          this.idCliente = this.usuarioLogado;
          if (this.idCliente) {
            this.addFormBasico.setValue({
              titulo: null,
              descricao: null,
              area: null,
              nivel: null,
              pessoaJuridicaId: this.idCliente || 0,
              servicoId: null,
              qtdeUnidades: 0,
              addUnidades: 0,
              urlLink: null,
              tipoCargo: "Modelo",
            });
            this.getServicoByCliente(this.idCliente);
          }
        } else {
          this.getClientes();
        }
      });
      this.dtOptions = {
        pagingType: 'full_numbers',
        pageLength: 10,
        processing: true,
        responsive: true,
        order: [],
        language: LanguageDataTable.portugues_datatables
      };
  }

  get f() { return this.addFormBasico.controls; }

  setIdCliente(event: number) {
    this.idCliente = event;
    this.servico$ = undefined;
    this.idServico = undefined;
    this.servicoSelect = undefined;

    if (!this.idCliente) {
      return this.idCliente = undefined;
    } else {
      this.addFormBasico.patchValue({ pessoaJuridicaId: this.idCliente });
      this.getServicoByCliente(this.idCliente);
    }
  }


  getClientes() {
    this.clientes$ = this.clientesService.v1ClienteGet().pipe(share());
    this.subs.sink = this.clientes$.subscribe(clientes => {
      if (clientes.length === 1) {
        clientes.forEach(clienteId => this.getServicoByCliente(clienteId.id));
      }
    });
  }

  getServicoByCliente(id: number) {
    this.servico$ = this.servicosService.v1ServicoClienteClienteIdGet(id);
  }

  selectServico(id: number) {
    this.idServico = id;
    if (this.idServico) {
      this.addFormBasico.patchValue({ servicoId: this.idServico });
    }
  }

  saveCargo(): void {

    this.submitted = true;

    if (this.addFormBasico.invalid) { return; }

    this.subs.sink = this.cargosService.v1CargoPost(this.addFormBasico.value)
    .subscribe(success => {
      this.dadosBasicosSalvos = true;
      this.alertService.showAlertSuccess('Dados Básicos cadastrados com sucesso!');
      this.idCargo = success.id;
      this.linkBasicsData.nativeElement.classList.remove('active');
      this.basicsData.nativeElement.classList.remove('active', 'show');
      this.linkProfile.nativeElement.classList.remove('disabled');
      this.linkProfile.nativeElement.classList.add('active');
      this.profile.nativeElement.classList.add('active', 'show');

      this.nomeCargo = success.titulo;
      this.unidades = success.qtdeUnidades;

      if (!this.nomeCliente) {
        this.nomeCliente = "ID: " + success.pessoaJuridicaId;
      }
      
      if (this.usuarioLogado && this.unidades !== this.initUnidades) {}

    }, error => {
      console.error("Erro:", error);
      if (error?.Erros && Array.isArray(error.Erros) && error.Erros.length > 0) {
        this.alertService.showAlertDanger(error.Erros[0].Mensagem);
      } else {
        this.alertService.showAlertDanger('Erro ao cadastrar Cargo Modelo. Por favor, verifique se existe um título ou tente mais tarde.');
      }
    });
    this.goTop();

  }

  atualizarCargo(): void {

    this.submitted = true;

    if (this.addFormBasico.invalid) { return; }

    this.subs.sink = this.cargosService.v1CargoCargoIdPut(this.idCargo, this.addFormBasico.value)
    .subscribe(success => {
      this.dadosBasicosSalvos = true;
      this.alertService.showAlertSuccess('Dados Básicos atualizados com sucesso!');
      this.idCargo = success.id;
      this.linkBasicsData.nativeElement.classList.remove('active');
      this.basicsData.nativeElement.classList.remove('active', 'show');
      this.linkProfile.nativeElement.classList.remove('disabled');
      this.linkProfile.nativeElement.classList.add('active');
      this.profile.nativeElement.classList.add('active', 'show');

      let cargo = success.titulo;
      let addUnidades = success.qtdeUnidades;

      if (!this.nomeCliente) {
        this.nomeCliente = "ID: " + success.pessoaJuridicaId;
      }
      
      if (this.usuarioLogado && addUnidades !== this.unidades) {}

    }, error => {
      console.error("Erro:", error);
      if (error?.Erros && Array.isArray(error.Erros) && error.Erros.length > 0) {
        this.alertService.showAlertDanger(error.Erros[0].Mensagem);
      } else {
        this.alertService.showAlertDanger('Erro ao atualizar Cargo Modelo. Por favor, verifique se existe um título ou tente mais tarde.');
      }
    });
    this.goTop();
  }

  goTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  goBack(): void {
    this.location.back();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }


}
